import _merge from 'lodash/merge';
import _concat from 'lodash/concat';
import { i18n } from '@/plugins/i18n';
import Vue from 'vue';
import { secureStorage } from '@/utils/secure-storage';

function generateSnackBar(options) {
  return _merge(
    {
      mode: '',
      color: 'primary',
      text: '',
      show: true,
      timeout: 6000,
    },
    options,
  );
}

export default {
  namespaced: true,
  state: {
    currentLocale: secureStorage.getItem('hello::currentLocale') || 'en',
    infoMessage: null,
    warningMessage: null,
    locales: [
      {
        text: 'EN',
        value: 'en',
      },
      {
        text: 'FR',
        value: 'fr',
      },
    ],
    snackbar: {
      show: false,
    },
    snackbarTimeout: null,
    snackbarText: [],

    displayAccountEmailPendingVerificationMessage: false,
    displayAccountCardRequiredMessage: false,
    cardDistributionMessage: {
      display: false,
      title: {
        en: 'CANADA POST STRIKE',
        fr: 'GRÈVE DE POSTES CANADA',
      },
      message: {
        en:
          'Please note that we are using Canada Post services for the delivery of physical cards. No cards can be delivered to your home until Canada Post resumes operations. We sincerely apologise for the inconvenience and kindly ask that you do not contact our customer service regarding this matter; it is a situation beyond our control. If you already have a physical card, the card is reloadable and the strike does not affect you.',
        fr:
          'Prenez note que nous utilisons les services de Postes Canada pour la livraison des cartes physiques. Aucune carte ne pourra être livrée à domicile avant la reprise des opérations de Postes Canada. Nous sommes sincèrement désolés des inconvénients et nous vous prions de ne pas solliciter notre service à la clientèle à cet effet; c’est une situation hors de notre contrôle. Si vous avez déjà une carte physique, la carte est rechargeable et la grève ne vous affecte pas.',
      },
    },
  },
  getters: {
    infoMessage: (state) => state.infoMessage,
    warningMessage: (state) => state.warningMessage,
    currentLocale: (state) => state.currentLocale,
    locales: (state) => state.locales,
    snackbar: (state) => state.snackbar,
    snackbarText: (state) => state.snackbarText,

    cardDistributionMessageDisplay: (state) => state.cardDistributionMessage.display,
    cardDistributionMessageTitle: (state) => state.cardDistributionMessage.title[state.currentLocale],
    cardDistributionMessageMessage: (state) => state.cardDistributionMessage.message[state.currentLocale],
    displayAccountEmailPendingVerificationMessage: (state) => state.displayAccountEmailPendingVerificationMessage,
    displayAccountCardRequiredMessage: (state) => state.displayAccountCardRequiredMessage,
  },
  mutations: {
    toggleCardDistributionMessageDisplay(state) {
      state.cardDistributionMessage.display = !state.cardDistributionMessage.display;
    },
    currentLocale(state, locale) {
      state.currentLocale = locale;
    },
    infoMessage(state, infoMessage) {
      state.infoMessage = infoMessage;
    },
    warningMessage(state, warningMessage) {
      state.warningMessage = warningMessage;
    },
    addSnackbar(state, { freshSnackbar, text }) {
      state.snackbar = freshSnackbar;
      state.snackbarText = _concat(state.snackbarText, text);
    },
    augmentSnackbar(state, text) {
      state.snackbar.mode = 'multi-line';
      state.snackbarText = _concat(state.snackbarText, text);
    },
    setSnackbarTimeout(state, timeout) {
      state.snackbarTimeout = timeout;
    },
    cleanSnackbar(state) {
      state.snackbar = {
        show: false,
      };
      state.snackbarTimeout = 0;
      state.snackbarText = [];
    },
  },
  actions: {
    async init({ dispatch }) {
      let defaultLocale = 'en';
      try {
        defaultLocale = secureStorage.getItem('hello::currentLocale') || (navigator.language || navigator.userLanguage).split('-')[0];

        const parameters = new URLSearchParams(window.location.search);
        const language = parameters.get('lang') || parameters.get('language') || parameters.get('locale');
        if (language) {
          console.log('LANGUAGE Detected', language); // eslint-disable-line no-console
          defaultLocale = language;
        }
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }

      await dispatch('changeLocale', defaultLocale);
    },

    showSuccessSnackBar({ commit, state }, { text }) {
      let timeout = 6000;
      let theTimeout;

      if (state.snackbar.show === false) {
        const freshSnackbar = generateSnackBar({ text, timeout });
        commit('addSnackbar', { freshSnackbar, text });

        theTimeout = setTimeout(() => {
          commit('cleanSnackbar');
        }, timeout);

        commit('setSnackbarTimeout', theTimeout);
      } else {
        clearTimeout(state.snackbarTimeout);

        const newTimeoutDuration = timeout;
        commit('augmentSnackbar', text);

        theTimeout = setTimeout(() => {
          commit('cleanSnackbar');
        }, newTimeoutDuration);

        commit('setSnackbarTimeout', theTimeout);
      }
    },

    changeLocale({ rootGetters, commit }, newLocale) {
      let setNewLocale = 'en';
      if (newLocale) {
        setNewLocale = newLocale.toLowerCase();
      }
      if (setNewLocale !== 'fr' && setNewLocale !== 'en') {
        setNewLocale = 'en';
      }

      i18n.locale = setNewLocale;
      Vue.prototype.$firebaseAuth.languageCode = setNewLocale;
      secureStorage.setItem('hello::currentLocale', setNewLocale);
      commit('currentLocale', setNewLocale);

      // Vue.prototype.$square.setLocale(`${setNewLocale}-CA`);

      if (window.hj) {
        const accountId = rootGetters['account/accountId'];
        hj('identify', accountId === '' || !accountId ? null : accountId, { language: rootGetters['ui/currentLocale'] });
      }
    },

    setInfoMessage({ commit }, infoMessage) {
      commit('infoMessage', infoMessage);
      setTimeout(() => commit('infoMessage', null), 10 * 1000);
    },

    setWarningMessage({ commit }, warningMessage) {
      commit('warningMessage', warningMessage);
      setTimeout(() => commit('warningMessage', null), 10 * 1000);
    },
  },
};
